/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  List, Container, Checkbox, Segment,
  Header, Divider, Button, Dimmer,
  Loader, Grid
} from "semantic-ui-react";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

export class TsExpertConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isSendingConfigDimmerActive: false,
      isRetriesProblemChecked: false,
      isDiagnosticProblemChecked: false,
      isFaultProblemChecked: false,
      // isFaultSequenceProblemChecked: false,
      isConfigErrorProblemChecked: false,
      isParamErrorProblemChecked: false,
      isMissingProblemChecked: false,
      isOnlineProblemChecked: false,
      isCriticalSlaveProblemChecked: false,
      isMasterFaultProblemChecked: false,
      isFiberLowerLimitMaintenanceRequiredProblemChecked: false,
      isFiberLowerLimitUrgentMaintenanceProblemChecked: false,
      isFiberSignalLostProblemChecked: false,
    };
  }

  retrieveData = () => {
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        isRetriesProblemChecked: data.isRetriesProblemChecked,
        isDiagnosticProblemChecked: data.isDiagnosticProblemChecked,
        isFaultProblemChecked: data.isFaultProblemChecked,
        // isFaultSequenceProblemChecked: data.isFaultSequenceProblemChecked,
        isConfigErrorProblemChecked: data.isConfigErrorProblemChecked,
        isParamErrorProblemChecked: data.isParamErrorProblemChecked,
        isMissingProblemChecked: data.isMissingProblemChecked,
        isOnlineProblemChecked: data.isOnlineProblemChecked,
        isCriticalSlaveProblemChecked: data.isCriticalSlaveProblemChecked,
        isMasterFaultProblemChecked: data.isMasterFaultProblemChecked,
      }));

    if (isFiberProcessOn) {
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/tsExpertConfig", { mode: "cors" })
        .then(res => res.json())
        .then(data => this.setState({
          isFiberLowerLimitMaintenanceRequiredProblemChecked: data.isFiberLowerLimitMaintenanceRequiredProblemChecked,
          isFiberLowerLimitUrgentMaintenanceProblemChecked: data.isFiberLowerLimitUrgentMaintenanceProblemChecked,
          isFiberSignalLostProblemChecked: data.isFiberSignalLostProblemChecked,
        }));
    } else {
      this.setState({
        isFiberLowerLimitMaintenanceRequiredProblemChecked: false,
        isFiberLowerLimitUrgentMaintenanceProblemChecked: false,
        isFiberSignalLostProblemChecked: false,
      });
    }
  }

  // ------ Toggle Checkboxes ---------
  toggleRetriesProblemCheckbox = () => {
    this.setState({ isRetriesProblemChecked: !this.state.isRetriesProblemChecked });
  }

  toggleDiagnosticProblemCheckbox = () => {
    this.setState({ isDiagnosticProblemChecked: !this.state.isDiagnosticProblemChecked });
  }

  toggleFaultProblemCheckbox = () => {
    this.setState({ isFaultProblemChecked: !this.state.isFaultProblemChecked });
  }

  toggleFaultSequenceProblemCheckbox = () => {
    this.setState({ isFaultSequenceProblemChecked: !this.state.isFaultSequenceProblemChecked });
  }

  toggleConfigErrorProblemCheckbox = () => {
    this.setState({ isConfigErrorProblemChecked: !this.state.isConfigErrorProblemChecked });
  }

  toggleParamErrorProblemCheckbox = () => {
    this.setState({ isParamErrorProblemChecked: !this.state.isParamErrorProblemChecked });
  }

  toggleMissingProblemCheckbox = () => {
    this.setState({ isMissingProblemChecked: !this.state.isMissingProblemChecked });
  }

  toggleOnlineProblemCheckbox = () => {
    this.setState({ isOnlineProblemChecked: !this.state.isOnlineProblemChecked });
  }

  toggleCriticalSlaveProblemCheckbox = () => {
    this.setState({ isCriticalSlaveProblemChecked: !this.state.isCriticalSlaveProblemChecked });
  }

  toggleMasterFaultProblemCheckbox = () => {
    this.setState({ isMasterFaultProblemChecked: !this.state.isMasterFaultProblemChecked });
  }

  toggleIsFiberLowerLimitMaintenanceRequiredProblemCheckbox = () => {
    this.setState({ isFiberLowerLimitMaintenanceRequiredProblemChecked: !this.state.isFiberLowerLimitMaintenanceRequiredProblemChecked });
  }

  toggleIsFiberLowerLimitUrgentMaintenanceProblemCheckbox = () => {
    this.setState({ isFiberLowerLimitUrgentMaintenanceProblemChecked: !this.state.isFiberLowerLimitUrgentMaintenanceProblemChecked });
  }

  toggleIsFiberSignalLostProblemCheckbox = () => {
    this.setState({ isFiberSignalLostProblemChecked: !this.state.isFiberSignalLostProblemChecked });
  }

  // Save the TS Expert Configuration
  saveTsExpertConfiguration = async () => {
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    this.showSendingConfigDimmer();

    const data = {
      isRetriesProblemChecked: this.state.isRetriesProblemChecked,
      isDiagnosticProblemChecked: this.state.isDiagnosticProblemChecked,
      isFaultProblemChecked: this.state.isFaultProblemChecked,
      // isFaultSequenceProblemChecked: this.state.isFaultSequenceProblemChecked,
      isConfigErrorProblemChecked: this.state.isConfigErrorProblemChecked,
      isParamErrorProblemChecked: this.state.isParamErrorProblemChecked,
      isMissingProblemChecked: this.state.isMissingProblemChecked,
      isOnlineProblemChecked: this.state.isOnlineProblemChecked,
      isCriticalSlaveProblemChecked: this.state.isCriticalSlaveProblemChecked,
      isMasterFaultProblemChecked: this.state.isMasterFaultProblemChecked,
    };

    const dataOpticFiber = {
      isFiberLowerLimitMaintenanceRequiredProblemChecked: this.state.isFiberLowerLimitMaintenanceRequiredProblemChecked,
      isFiberLowerLimitUrgentMaintenanceProblemChecked: this.state.isFiberLowerLimitUrgentMaintenanceProblemChecked,
      isFiberSignalLostProblemChecked: this.state.isFiberSignalLostProblemChecked,
    };

    try {
      await fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify(data)
      }).then(UtilsInstance.checkStatus);

      if (isFiberProcessOn) {
        await fetch(Constants.REQUEST_IP_ADDRESS + "fiber/tsExpertConfig_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: JSON.stringify(dataOpticFiber)
        }).then(UtilsInstance.checkStatus);
      }

      alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
    } catch (error) {
      alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + Strings.REASON + error);
    } finally {
      this.hideSendingConfigDimmer();
    }
  }

  opticFiberEvents = () => {
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    if (isFiberProcessOn) {
      return (
        <>
          <List.Item>
            <Grid columns={2}>
              <Grid.Column width={14}>
                <List.Header>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER}</List.Header>
                {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT}
              </Grid.Column>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                <Checkbox
                  toggle
                  onChange={this.toggleIsFiberLowerLimitMaintenanceRequiredProblemCheckbox}
                  checked={this.state.isFiberLowerLimitMaintenanceRequiredProblemChecked} />
              </Grid.Column>
            </Grid>
          </List.Item>

          <List.Item>
            <Grid columns={2}>
              <Grid.Column width={14}>
                <List.Header>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER}</List.Header>
                {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT}
              </Grid.Column>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                <Checkbox
                  toggle
                  onChange={this.toggleIsFiberLowerLimitUrgentMaintenanceProblemCheckbox}
                  checked={this.state.isFiberLowerLimitUrgentMaintenanceProblemChecked} />
              </Grid.Column>
            </Grid>
          </List.Item>

          <List.Item>
            <Grid columns={2}>
              <Grid.Column width={14}>
                <List.Header>{Strings.FIBER_SIGNAL_LOSS_LIST_HEADER}</List.Header>
                {Strings.FIBER_SIGNAL_LOSS_LIST_CONTENT}
              </Grid.Column>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                <Checkbox
                  toggle
                  onChange={this.toggleIsFiberSignalLostProblemCheckbox}
                  checked={this.state.isFiberSignalLostProblemChecked} />
              </Grid.Column>
            </Grid>
          </List.Item>
        </>
      );
    } else {
      return;
    }
  }

  showSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: true });

  hideSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: false });

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    return (
      <Container text>
        <Segment>
          <Header as='h2' textAlign="center" color="teal">
            {Strings.TS_EXPERT_CONFIGURATION}
          </Header>
          <Divider clearing />

          <Segment id="problems-list" style={listSegmentStyle} basic>

            <List divided verticalAlign='middle'>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.CONFIG_RETRIES_LIST_HEADER}</List.Header>
                      {Strings.CONFIG_RETRIES_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleRetriesProblemCheckbox}
                        checked={this.state.isRetriesProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.CONFIG_DIAGNOSTIC_LIST_HEADER}</List.Header>
                      {Strings.CONFIG_DIAGNOSTIC_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleDiagnosticProblemCheckbox}
                        checked={this.state.isDiagnosticProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.CONFIG_FAULT_LIST_HEADER}</List.Header>
                      {Strings.CONFIG_FAULT_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleFaultProblemCheckbox}
                        checked={this.state.isFaultProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              {/* <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.CONFIG_FAULT_SEQUENCE_LIST_HEADER}</List.Header>
                      {Strings.CONFIG_FAULT_SEQUENCE_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleFaultSequenceProblemCheckbox}
                        checked={this.state.isFaultSequenceProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item> */}

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.CONFIG_CONFIG_ERROR_LIST_HEADER}</List.Header>
                      {Strings.CONFIG_CONFIG_ERROR_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleConfigErrorProblemCheckbox}
                        checked={this.state.isConfigErrorProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.CONFIG_PARAM_ERROR_LIST_HEADER}</List.Header>
                      {Strings.CONFIG_PARAM_ERROR_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleParamErrorProblemCheckbox}
                        checked={this.state.isParamErrorProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.CONFIG_MISSING_LIST_HEADER}</List.Header>
                      {Strings.CONFIG_MISSING_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleMissingProblemCheckbox}
                        checked={this.state.isMissingProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.CONFIG_ONLINE_LIST_HEADER}</List.Header>
                      {Strings.CONFIG_ONLINE_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleOnlineProblemCheckbox}
                        checked={this.state.isOnlineProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.CONFIG_CRITICAL_SLAVE_LIST_HEADER}</List.Header>
                      {Strings.CONFIG_CRITICAL_SLAVE_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleCriticalSlaveProblemCheckbox}
                        checked={this.state.isCriticalSlaveProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.CONFIG_MASTER_FAULT_LIST_HEADER}</List.Header>
                      {Strings.CONFIG_MASTER_FAULT_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleMasterFaultProblemCheckbox}
                        checked={this.state.isMasterFaultProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              {this.opticFiberEvents()}

            </List>

          </Segment>

          <Button
            fluid
            color="teal"
            content={Strings.SAVE}
            onClick={this.saveTsExpertConfiguration} />

          <Dimmer active={this.state.isSendingConfigDimmerActive} >
            <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
          </Dimmer>

        </Segment>

      </Container >
    );
  }
}

const listSegmentStyle = {
  overflowY: "scroll",
  height: "56vh"
};

export default TsExpertConfig;
